import HeadTittle from "../../../../../components/HeadTittle";
import {
    CheckOutlineIcon,
    CommentOutlineIcon,
    DeniedOutlineIcon,
    InfoChip,
} from "../../../../../components/buttons/IconButtons";
import {InvitationDocumentationApp} from "../Functionality/InvitationDocumentationApp";
import CustomCard from "../../../../../components/CustomCard";
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import FieldsCard from "./FieldsCard";
import {getDateTimeFromTimestamp, getFullName} from "../../../../../Apis/functions";
import {STATUS_MODEL} from "../../../../../enums/statusEnum";
import GeneralCommentRequestModal from "../Modal/GeneralCommentRequestModal";
import CustomUserChip from "../../../../../components/CustomUserChip";
import {POSITION_MODEL} from "../../../../../Helpers/PositionModel";
import React from "react";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const InvitationDocumentation = () => {

    const {
        resultsToShow,
        setShowApprove,
        setShowDenied,
        setShowIssueComment,
        setRow,
        styles,
        genericCommentModals,
        setModified,
        modified,
        t,
        disabled,
        dispatch,
        currentStatusConfig,
        handleOnBack,
        pendingToUpload,
        isOverdue,
        showButtonsToApprove
    } = InvitationDocumentationApp()

    return (
        <>
            <HeadTittle name={t('documentation')} onBack={handleOnBack}/>
            { currentStatusConfig &&
                <>
                    { isOverdue ?
                        <>
                            {  showButtonsToApprove &&
                                <CustomUserChip
                                    className="my-3 chip-error-code-150-100 justify-content-start d-flex"
                                    name={t('invitation_has_expired_it_is_not_possible_complete_review')}
                                    Icon={InfoChip}
                                    showAvatar={true}
                                    classNameIcon={"icon-color-error-code-700"}
                                    variant="large"
                                    iconPosition={POSITION_MODEL.LEFT}
                                />
                            }
                        </>
                        :
                        <div className={"d-flex justify-content-end gap-3 mb-16px"}>
                            { showButtonsToApprove &&
                                (
                                    <>
                                        <ButtonAction
                                            Icon={CheckOutlineIcon}
                                            id='btn_id_approved_modal'
                                            className={'btn-icon-svg-chip-button btn-outlined-success-600 w-40px h-40px minw-40px p-0'}
                                            iconProps={'icon'}
                                            iconClass={"mr-0"}
                                            disabled={currentStatusConfig.id === STATUS_MODEL.PENDING_TO_UPLOAD_INFORMATION}
                                            onClick={() => {
                                                setRow(resultsToShow?.invitation?.id)
                                                setShowApprove(true);
                                            }}
                                        />
                                        <ButtonAction
                                            Icon={DeniedOutlineIcon}
                                            id='btn_id_denied_modal'
                                            className={'btn-icon-svg-chip-button btn-outlined-error-600 w-40px h-40px minw-40px p-0'}
                                            iconProps={'icon'}
                                            iconClass={"mr-0"}
                                            disabled={currentStatusConfig.id === STATUS_MODEL.PENDING_TO_UPLOAD_INFORMATION}
                                            onClick={() => {
                                                setRow(resultsToShow?.invitation?.id)
                                                setShowDenied(true);
                                            }}
                                        />
                                        <ButtonAction
                                            Icon={CommentOutlineIcon}
                                            id='btn_id_comment_modal'
                                            className={'btn-icon-svg-chip-button btn-outlined-warning-600 w-40px h-40px minw-40px p-0'}
                                            iconProps={'icon'}
                                            iconClass={"mr-0"}
                                            disabled={currentStatusConfig.id === STATUS_MODEL.PENDING_TO_UPLOAD_INFORMATION}
                                            onClick={() => {
                                                setRow(resultsToShow?.invitation?.id)
                                                setShowIssueComment(true);
                                            }}
                                        />
                                    </>
                                )
                            }
                        </div>
                    }

                    <CustomCard
                        classCard={`${currentStatusConfig.classCard}`}
                        children={
                            <div className={`d-flex flex-column justify-content-start gap-12px` }>
                                <p className={`ibl-font-w-600 fs-14px ${currentStatusConfig.fontColor}`}>{t(currentStatusConfig.tittle)}</p>
                                <p className={"fs-12px ibl-font-w-600"}>{t(resultsToShow?.invitation?.statusReason)}</p>
                                {
                                    currentStatusConfig.id !== STATUS_MODEL.PENDING_TO_UPLOAD_INFORMATION &&
                                    <p className={"fs-12px"}>
                                        {t(currentStatusConfig.toast)} : {" "}
                                        <span className={"ibl-font-w-600"}>
                                    {resultsToShow?.invitation?.visitorStatusId === STATUS_MODEL.CANCELED ?
                                        getFullName(resultsToShow?.invitation?.visitorName,
                                            resultsToShow?.invitation?.visitorLastName,
                                            resultsToShow?.invitation?.visitorSecondLastName
                                        ):getFullName(resultsToShow?.invitation?.hostName,
                                            resultsToShow?.invitation?.hostLastName,
                                            resultsToShow?.invitation?.hostSecondLastName
                                        )}
                            </span>
                                        {" "}·{" "}
                                        {getDateTimeFromTimestamp(resultsToShow?.invitation?.updatedAt)}.
                                    </p>
                                }
                            </div>
                        }
                    />
                    <FieldsCard
                        data={resultsToShow}
                        pendingToUpload={pendingToUpload}
                        currentStatusConfig={currentStatusConfig}
                        styles={styles}
                        t={t}
                        disabled={disabled}
                        dispatch={dispatch}
                    />
                    {genericCommentModals.map(({ show,
                                                   setter,
                                                   title,
                                                   setRow,
                                                   row,
                                                   status,
                                                   module,endPoint}, idx) => {
                            return (
                                <>
                                    <GeneralCommentRequestModal
                                        show={show}
                                        setRow={setRow}
                                        onHide={() => setter(false)}
                                        title={title}
                                        setModified={setModified}
                                        modified={modified}
                                        row={row}
                                        status={status}
                                        module={module}
                                        endPoint={endPoint}
                                    />
                                </>
                            )
                        }
                    )}
                </>
            }
        </>
    )
}

export default InvitationDocumentation
